import { Component, OnInit, ViewChild } from '@angular/core';
import { BookingStatsLineItem } from '../booking-stats-line-item';
import { HttpService } from '../service/http.service';

@Component({
  selector: 'app-simple-booking-stats',
  templateUrl: './simple-booking-stats.component.html',
  styleUrls: ['./simple-booking-stats.component.css']
})
export class SimpleBookingStatsComponent implements OnInit {

  yearRange = [2021, 2020];
  selectedYear = 2021;
  lineItems: BookingStatsLineItem[] = [];
  data: any;

  @ViewChild("chart") chart: any;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.httpService.getStatsLineItems().subscribe(res => {
      this.lineItems = res;
      for(let item of this.lineItems){
        this.data.labels.push(item.departureYear.toString());
        this.data.datasets[0].data.push(item.bookings);
        this.data.datasets[1].data.push(item.duration);
      }
      console.log(this.data);
      this.chart.refresh();
    });
    this.data = {
      labels: [],
      datasets: [
        {
          label: "Bookings", 
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.4)"
        },
        {
          label: "Weeks", 
          data: [],
          backgroundColor: "rgba(30, 99, 255, 0.4)"
        }
      ]
  }
  }

  changeYear(){
    this.httpService.getStatsLineItems().subscribe(res => {
      this.lineItems = res;
    });
  }

}
